import { mapKeys } from 'lodash-es'

export const SUCCESS = 'Success'
export const PARTIALLY_SUCCESSFULL = 'PartialSuccess'
export const ERROR = 'Error'
export const IN_PROGRESS = 'InProgress'

export const SCRAPING_RESPONSE_STATUSES = mapKeys(
  [
    { name: 'Success', value: SUCCESS },
    { name: 'PartialSuccess', value: PARTIALLY_SUCCESSFULL },
    { name: 'Error', value: ERROR },
    { name: 'InProgress', value: IN_PROGRESS },
  ],
  'value',
)
